import React, { useCallback, useEffect } from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import {
  changeAdminEmailToSave,
  changeAdminPhoneToSave,
  changeMessageToSave,
  changeShowMessageToSave,
  loadSafety,
  changeSafety,
  resetToSave,
  getSafetyPreview,
} from "./safety.actions";
import { AdminInfo } from "../../components/adminInfo/AdminInfo";
import { TabControls } from "../../components/tabControls/TabControls";
import { withPromptDialog } from "../../../../hocs/withPrompt";
import { useMalwareForm } from "./useMalwareForm";
import { useMount } from "@sportal/cdk/hooks";
import { getFromSafetyValidation, isSafetyFetched } from "./safety.selectors";
import { BlockingMessage } from "../../components/blockingMessage/BlockingMessage";
import { previewPage } from "../shared.actions";
import { Form } from "../../../../components/form";
import { Desktop, TabletMobile } from "../../../../hocs/Responsive";
import { AriaPageTitle } from "../../../../components/ariaPageTitle";

const MalwareFormContent = withPromptDialog(({ hasChanges, save, discard }) => {
  const dispatch = useDispatch();

  const isFetched = useSelector(isSafetyFetched);
  const rules = useSelector(getFromSafetyValidation("rules"), _.isEqual);

  const { isValid, formValues, isEmailPatternValid } = useMalwareForm();

  useMount(() => {
    !isFetched && dispatch(loadSafety());
  });

  const preview = async () =>
    await previewPage(dispatch, getSafetyPreview(), "safety");

  return (
    <section className="malware-form">
      <AriaPageTitle pageKey="page_title_service_page_malware" />
      <Desktop>
        <h1 className={"blocked-page__title"}>
          <FormattedMessage id={"malware_and_phishing"} />
        </h1>
      </Desktop>
      <TabletMobile>
        <h2 className={"blocked-page__title"}>
          <FormattedMessage id={"malware_and_phishing"} />
        </h2>
      </TabletMobile>
      <section className={"blocked-page__description"}>
        <FormattedMessage id={"malware_and_phishing_description"} />
      </section>
      <Form
        onSubmit={save}
        name={"malwareForm"}
        description={
          <FormattedMessage id={"malware_and_phishing_form_description"} />
        }
        hiddenDescription
      >
        <BlockingMessage
          showMessage={formValues.showMessage}
          toggleMessage={() => dispatch(changeShowMessageToSave())}
          changeMessage={(e) => dispatch(changeMessageToSave(e.target.value))}
          message={formValues.message}
          messageValidation={rules.message}
        />
        <AdminInfo
          email={{
            value: formValues.adminEmail,
            action: (adminEmail) =>
              dispatch(changeAdminEmailToSave(adminEmail)),
            validation: rules.adminEmail,
            isEmailPatternValid,
          }}
          phone={{
            value: formValues.adminPhone,
            action: (adminPhone) =>
              dispatch(changeAdminPhoneToSave(adminPhone)),
            validation: rules.adminPhone,
          }}
        />

        <TabControls
          isFormValid={isValid}
          isFormUnchanged={!hasChanges}
          onReset={discard}
          onPreview={preview}
        />
      </Form>
    </section>
  );
});

export const MalwareForm = () => {
  const dispatch = useDispatch();
  const { hasChanges, isValid } = useMalwareForm();

  const save = () => dispatch(changeSafety());
  const discard = useCallback(() => dispatch(resetToSave()), [dispatch]);

  useEffect(() => {
    return () => discard();
  }, [discard]);

  return (
    <MalwareFormContent
      hasChanges={hasChanges && isValid}
      save={save}
      discard={discard}
    />
  );
};
